import React, {Component} from "react";
import {connect} from "react-redux";
import { newSeasonFilterStyle } from "../../../services/utils";
import ReactSelect, {components} from "react-select";
import {
  setEventStatsSaison
} from "../../../actions/actions/eventStats";
import {getSeasonsValues} from "../../../actions/thunks/eventStats";
import _ from 'lodash';

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'}/>
    </components.DropdownIndicator>
  );
};

class SaisonFilter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      seasons: [],
    };
  }

  componentDidMount() {
    this.getSeasons();
  }

  componentDidUpdate(nextProps, nextState, nextContext) {
    if (nextProps.eventStatsFilter.year !== this.props.eventStatsFilter.year) {
      this.getSeasons();
    }

    if(nextProps.seasons && (nextProps.seasons.items !== this.props.seasons.items)) {
      let seasons = this.props.seasons.items;
      let newSeasons = [];
      
      newSeasons = seasons.map(part => {
        let label = '';
        if (part.name_fr) {
          label = part.name_fr;
        } else if (part.name_en) {
          label = part.name_en;
        } else if (part.name_nl) {
          label = part.name_nl;
        }
  
        return { label, value: part.id };
      });
  
      newSeasons.unshift({ value: 'ALL', label: 'TOUTES LES FORMATS' });
      newSeasons.push({ value: 'NONE', label: 'AUCUNE FORMAT' });
  
      this.setState({ seasons: newSeasons });
    }
  }

  getSeasons = () => {
    let params = {};

    if(this.props.auth.currentClient) {
      params.issuerId = this.props.auth.currentClient.id;
    }

    this.props.getSeasonsValues(params);
  }

  handleSelectChange = (value) => {
    this.props.setEventStatsSaison(value.value);
  }

  render() {
    return (
      <ReactSelect
        onChange={this.handleSelectChange}
        styles={newSeasonFilterStyle()}
        defaultValue={{ value: 'ALL', label: 'TOUTES LES FORMATS'}}
        options={this.state.seasons}
        components={{ DropdownIndicator, IndicatorSeparator:() => null, Input:() => null}}
      />
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  seasons: state.seasons,
  auth: state.auth
});

const mapDispatchToProps = {
  setEventStatsSaison,
  getSeasonsValues
};

export default connect(mapStateToProps, mapDispatchToProps)(SaisonFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/SaisonFilter.js